import {
  apiDeleteComplianceService,
  apiGetComplianceService,
  apiPostComplianceService,
  apiPutComplianceService,
  buildMerchantId,
  buildMerchantIdForEmployeeKey,
} from '../utils/api'

export function updateMerchant(companyId, shopId, data) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiPutComplianceService(`merchants/${merchantId}`, data)
}

export function updateMerchantEmployeeKey(companyId, employeeId, data) {
  const merchantId = buildMerchantIdForEmployeeKey(companyId)
  return apiPutComplianceService(`merchants/${merchantId}/employees/${employeeId}`, data)
}

export function deletedMerchantEmployeeKey(companyId, employeeId) {
  const merchantId = buildMerchantIdForEmployeeKey(companyId)
  const params = { compliance: 'METRC' }
  return apiDeleteComplianceService(
    `merchants/${merchantId}/employees/${employeeId}/credentials`,
    params,
  )
}

export function getOAuthStatus(companyId, shopId) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiGetComplianceService(`merchants/${merchantId}/oauth/token-status`)
}

export function getAuthorizationUrl(companyId, shopId, redirectAfter) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiGetComplianceService(
    `merchants/${merchantId}/oauth/authorization-url?redirectAfter=${redirectAfter}`,
  )
}

export function getMerchantCredentials(companyId, shopId) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiGetComplianceService(`merchants/${merchantId}`)
}

export function lookupUser(companyId, shopId, data) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiPostComplianceService(`merchants/${merchantId}/users/lookup`, data)
}

export function syncUser(companyId, shopId, data) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiPostComplianceService(`merchants/${merchantId}/users/sync`, data)
}

export function createUser(companyId, shopId, data) {
  const merchantId = buildMerchantId(companyId, shopId)
  return apiPostComplianceService(`merchants/${merchantId}/users`, data)
}



// WEBPACK FOOTER //
// ./src/api/complianceService.js